<div class="content-wrapper max-width-p">
  <app-notification-banner></app-notification-banner>

    <div class="voucher-container" *ngIf="eventInfo.hasActiveEvent">

        <div class="voucher-banner-background card clickable col-12"  (click)="openGiftVouchersPage()">
            <div class="voucher-container">
                <div class="col-md-5 col-12 voucher-logo">
                    <img src="{{'DASHBOARD.VOUCHERS.LOGO' | translate}}" />
                </div>
                <div class="d-none d-md-block col-md-7 voucher-text responsive-text" style="display:block">
                    <div>{{'DASHBOARD.VOUCHERS.TEXT_LINE_1' | translate}}</div>
                    <div>{{'DASHBOARD.VOUCHERS.TEXT_LINE_2' | translate}}</div>
                    <div>{{eventInfo.startDate}} - {{eventInfo.endDate}}</div>
                </div>

            </div>
        </div>

    </div>
  <div class="content-body">
    <div class="left">
      <div class="summary-wrapper card"  *ngIf="userCompanyInfo.hasFlexibleBenefits === true">
        <available-budget *ngIf="showBudgets === true"
          [expander]="userCompanyInfo.pricingPlan == PricingPlan.FLEX"
          [hasTransportBudget]= "this.userCompanyInfo?.hasTransportBudget"
          [hasProfessionalDevelopmentBudget] = "this.userCompanyInfo?.hasProfessionalDevelopmentBudget"
          [hasCashbackBudget] = "this.userCompanyInfo?.hasCashbackBudget"
          [standardBudget] = "this.userDashboardInfo?.totalAmount"
          [transportBudget] = "this.userDashboardInfo?.totalAmountTransport"
          [cashbackBudget] = "this.userDashboardInfo?.totalAmountCashback"
          [professionalDevelopmentBudget] = "this.userDashboardInfo?.totalAmountProfessionalDevelopment"
          [cashbackPendingAmount]= "this.pendingCashbackAmount"
          [bigText]="this.bigText"
        >
        </available-budget>
        <available-budget *ngIf="showBudgets === false"
          [expander]="false"
          smallText="{{ 'DASHBOARD.USER_INFO.TOTAL_BUDGET' | translate }}"
          [bigText]="this.bigText"
        >
        </available-budget>
        <div class="horizontal-divider" *ngIf="userCompanyInfo.pricingPlan === PricingPlan.FLEX"></div>
        <div class="space-between fs-12" *ngIf="userCompanyInfo.pricingPlan === PricingPlan.FLEX">
          <div class="icon-text-container">
            <i [data-feather]="'lock'" class="custom-margin"></i>
            <div class="font-semibold" ngbTooltip="{{ 'DASHBOARD.USER_INFO.MONTHLY_COST_TOOLTIP' | translate }}">
              {{ 'DASHBOARD.USER_INFO.MONTHLY_COSTS' | translate }}
            </div>
            <a [routerLink]="['/' + subdomain + '/benefits-history/recurrent']" style="margin-left: -5px; margin-bottom: 3px">
              <i [data-feather]="'external-link'"></i>
            </a>
          </div>
          <div class="font-bold">
            {{
              userDashboardInfo?.reservedAmount
                ? userDashboardInfo?.reservedAmount
                : 0
            }}
            {{ 'DASHBOARD.UNIT' | translate }}
          </div>
        </div>
      </div>
      <div class="add-benefit-wrapper card" *ngIf="isMobile && userCompanyInfo.hasFlexibleBenefits === true" >
        <div class="add-benefit-content">
          <a
            [routerLink]="['/' + subdomain + '/flexible-benefits']"
            href="javascript:void(0)"
            class="add-benefit-button btn-primary"
          >
            <i class="fa fa-plus-square-o"></i>
            {{ 'DASHBOARD.TOP_BENEFITS.ADD_BENEFITS.ADD_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
          </a>
        </div>
      </div>
      <app-budget-details
        *ngIf="userCompanyInfo.pricingPlan == PricingPlan.FLEX && userCompanyInfo.hasFlexibleBenefits === true"
        [userCompanyInfo]="userCompanyInfo"
        [userDashboardInfo]="userDashboardInfo"
        [manualLoadTransport]="manualLoadTransport"
        [manualLoadProfessionalDevelopment]="manualLoadProfessionalDevelopment">
      </app-budget-details>
    <div class="card" *ngIf="this.userCompanyInfo?.hasCashbackBudget === true">
        <div class="card-header pb-0">
            <div class="category-text">
                {{ 'CASHBACK.HOME_PAGE.CARD_TITLE' | translate }}
            </div>
            <div class="horizontal-divider"></div>
        </div>
        <div class="card-body text-left">
            <p>{{ 'CASHBACK.HOME_PAGE.CARD_SUBTITLE' | translate }}</p>
            <a class="btn btn-secondary" [routerLink]="'/' + this.subdomain + '/deals'">{{ 'CASHBACK.HOME_PAGE.CARD_ACTION' | translate }}</a>
        </div>
    </div>
      <div class="chart-wrapper card" *ngIf="userCompanyInfo.pricingPlan == PricingPlan.FLEX && userCompanyInfo.hasFlexibleBenefits === true">
        <!-- Bar Chart Start -->
        <div class="p-absolute" *ngIf="noChartData">
          <img src="../../../../assets/images/bar-chart.svg" alt="" />
          <div class="font-semibold">
            {{ 'DASHBOARD.CHART_INFO.NO_DATA_TITLE' | translate }}
          </div>
          <div>{{ 'DASHBOARD.CHART_INFO.NO_DATA_INFO' | translate }}</div>
        </div>
        <div>
          <div
            class="
              card-header
              d-flex
              justify-content-between
              align-items-sm-center align-items-start
              flex-sm-row flex-column
            "
          >
            <div class="header-left">
              <h4 class="card-title">
                {{ 'DASHBOARD.CHART_INFO.MONTHLY_BUDGET' | translate }}
              </h4>
            </div>
          </div>
          <div class="card-body">
            <div id="chartjs-bar-chart">
              <canvas
                baseChart
                #barChartRef
                height="400"
                [datasets]="barChart.datasets"
                [labels]="barChart.labels"
                [options]="barChart.options"
                [legend]="barChart.legend"
                [chartType]="barChart.chartType"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="userCompanyInfo.benefitsInfoDocument || userCompanyInfo.tosDocumentUrl || faqLinkIsSet">
          <div class="card-header pb-0">
              <div class="category-text">
                  {{'DASHBOARD.BENEFIT_GUIDE.GUIDE_TITLE' | translate}}
              </div>
              <div class="horizontal-divider"></div>
          </div>
        <div class="card-body documents-container">
          <div class="border-container">
            <a
              *ngIf="this.faqLinkIsSet && this.faqLinkIsSet === true"
              href="{{this.faqLink}}"
              class="document-card"
              target="_blank"
            >
              <span [ngClass]="'icon-book-open'" class="ficon feather"></span>
              <div class="text-card">
                {{'PROFILE_MENU.FAQ' | translate}}
              </div>
            </a>

            <a
              *ngIf="this.userCompanyInfo.benefitsInfoDocument !== null"
              href="{{this.userCompanyInfo.benefitsInfoDocument}}"
              class="document-card"
              target="_blank"
            >
              <span [ngClass]="'icon-file-text'" class="ficon feather"></span>
              <div class="text-card">
                {{'DASHBOARD.BENEFIT_GUIDE.BENEFITS_INFO' | translate}}
              </div>
            </a>

            <a
            *ngIf="this.userCompanyInfo.tosDocumentUrl !== null"
            href="{{this.userCompanyInfo.tosDocumentUrl}}"
            class="document-card"
            target="_blank"
          >
            <span [ngClass]="'icon-file-text'" class="ficon feather"></span>
            <div class="text-card">
              [ {{ this.userCompanyInfo.companyName }} ] {{'DASHBOARD.BENEFIT_GUIDE.TERMS_AND_CONDITIONS' | translate}}
            </div>
          </a>
          </div>
        </div>
      </div>

    </div>
    <div class="right">
      <div class="add-benefit-wrapper card" *ngIf="!isMobile && userCompanyInfo.hasFlexibleBenefits === true">
        <div class="add-benefit-content">
          <a
            [routerLink]="['/' + subdomain + '/flexible-benefits']"
            href="javascript:void(0)"
            class="add-benefit-button btn-primary"
          >
            <i class="fa fa-plus-square-o"></i>
            {{ 'DASHBOARD.TOP_BENEFITS.ADD_BENEFITS.ADD_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
          </a>
        </div>
      </div>
      <div class="card" *ngIf="this.userCompanyInfo?.hasFixedBenefits === true">
            <div class="card-header pb-0">
                <div class="category-text">
                    {{ 'DASHBOARD.FIXED_BENEFITS.TITLE' | translate }}
                </div>
                <div class="horizontal-divider"></div>
            </div>
            <div class="card-body text-left">
                <p>{{ 'DASHBOARD.FIXED_BENEFITS.DESCRIPTION' | translate }}</p>
                <a class="btn btn-secondary" [routerLink]="'/' + this.subdomain + '/fixed-benefits'">{{ 'DASHBOARD.FIXED_BENEFITS.CTA' | translate }}</a>
            </div>
        </div>
      <div class="benefits-wrapper card"  *ngIf="userCompanyInfo.hasFlexibleBenefits === true">
        <div class="space-between">
          <div class="benefits-history-wrapper" >
            <div class="category-text">
              {{ 'DASHBOARD.TOP_BENEFITS.BENEFITS.TITLE_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
            </div>
          </div>
        </div>
        <div class="horizontal-divider"></div>
        <div
          class="benefits"
          *ngIf="top5BenefitsOrders && top5BenefitsOrders.length > 0"
        >
          <div
            class="flex-column"
            *ngFor="
              let top5BenefitsOrder of top5BenefitsOrders;
              let idx = index
            "
          >
            <div class="benefit-item-wrapper">
              <a [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + top5BenefitsOrder.providerId + '/' + top5BenefitsOrder.benefitId]"
                     href="javascript:void(0)" style="color:inherit;">
                <div class="text-bold">
                    {{ top5BenefitsOrder.benefitName }}
                </div>
              </a>
              <div class="space-between">
                <div class="benefit-item-content">
                    <a [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + top5BenefitsOrder.providerId + '/' + top5BenefitsOrder.benefitId]"
                       href="javascript:void(0)">
                      <img
                        class="benefit-item-image"
                        [src]="top5BenefitsOrder.pictureUrl"
                        [alt]="top5BenefitsOrder.benefitName"
                      />
                    </a>
                  <div class="benefit-item-details">
                    <div class="text-bold">
                      {{ top5BenefitsOrder.price | number : '1.2-2'}}
                      {{ 'DASHBOARD.UNIT' | translate }}
                    </div>
                    <div class="benefit-item-text">
                      <span
                        class="active"
                        [ngClass]="{
                          'badge-danger':
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.RequestToBeCancelled ||
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.Cancelled ||
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.PaymentRefused,
                          'badge-warning':
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.PaymentPending ||
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.Shipping,
                          'badge-primary':
                            top5BenefitsOrder.orderStatus ===
                            orderStatuses.Created,
                          'badge-success':
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.PaymentAccepted ||
                            top5BenefitsOrder.orderStatus ===
                              orderStatuses.Completed
                        }"
                      ></span>
                      <div class="text-bold">
                        <!-- TODO foloseste marea parsare de pe benefit history item, check design also ca sa intelegi ce vrea de acolo -->
                        {{ top5BenefitsOrder.orderStatusLabel | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <a
                  [routerLink]="[
                    '/' +
                      subdomain +
                      '/benefit-details/order/' +
                      top5BenefitsOrder.itemId
                  ]"
                  href="javascript:void(0)"
                  class="btn btn-secondary"
                >
                  {{ 'DASHBOARD.TOP_BENEFITS.BENEFITS.DETAILS' | translate }}
                </a>
              </div>
            </div>
            <div
              class="horizontal-divider"
              *ngIf="idx < top5BenefitsOrders.length - 1"
            ></div>
          </div>
        </div>
        <div
          class="no-benefits"
          *ngIf="!top5BenefitsOrders || top5BenefitsOrders.length === 0"
        >
          <div class="categories">
            <div class="square-icon blue">
              <span class="ficon icon-flag feather"></span>
            </div>
            <div class="square-icon green">
              <img src="../../../../assets/images/lotus.png" alt="" />
            </div>
            <div class="square-icon purple">
              <img src="../../../../assets/images/badge.png" alt="" />
            </div>
            <div class="square-icon dark-blue">
              <span class="ficon icon-shopping-bag feather"></span>
            </div>
            <div class="square-icon orange">
              <span class="ficon icon-gift feather"></span>
            </div>
            <div class="square-icon red">
              <span class="ficon icon-heart feather"></span>
            </div>
          </div>
          <div class="text-bold">
            {{ 'DASHBOARD.TOP_BENEFITS.BENEFITS.NO_BENEFITS_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
            <a
              href="javascript:void(0)"
              [routerLink]="['/' + subdomain + '/flexible-benefits']"
            >
              {{
                'DASHBOARD.TOP_BENEFITS.BENEFITS.DISCOVER_BENEFITS_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate
              }}
              <i class="fa fa-chevron-right"></i>
            </a>
          </div>
        </div>
        <div class="horizontal-divider"></div>
        <div class="align-center">
          <a
            [routerLink]="['/' + subdomain + '/benefits-history']"
            href="javascript:void(0)"
            class="c-company"
          >
            {{ 'DASHBOARD.TOP_BENEFITS.BENEFITS.BENEFITS_HISTORY' | translate }}
            <i class="fa fa-chevron-right"></i>
          </a>
        </div>
      </div>
      <div class="card" *ngIf="userCompanyInfo.hasFlexibleBenefits === true">
        <div class="card-header" >
          <div class="category-text">
            {{ 'DASHBOARD.ORDERS_CATEGORIES.CATEGORIES' | translate }}
          </div>
          <div class="subtitle-text">
            {{ 'DASHBOARD.ORDERS_CATEGORIES.LAST_12_MONTHS' | translate }}
          </div>
          <div class="horizontal-divider"></div>
        </div>
        <div
          class="card-body"
          *ngFor="let orderOnCategory of orderOnCategories"
        >
          <div class="media align-items-center">
            <div
              class="square-icon"
              [ngClass]="{
                green: orderOnCategory.iconId === 0,
                blue: orderOnCategory.iconId === 1,
                purple: orderOnCategory.iconId === 2,
                'dark-blue': orderOnCategory.iconId === 3,
                orange: orderOnCategory.iconId === 4,
                red: orderOnCategory.iconId === 5
              }"
            >
              <img
                src="../../../../assets/images/lotus.png"
                alt=""
                *ngIf="orderOnCategory.iconId === 0"
              />
              <span
                class="ficon feather icon-flag"
                *ngIf="orderOnCategory.iconId === 1"
              ></span>
              <img
                src="../../../../assets/images/badge.png"
                alt=""
                *ngIf="orderOnCategory.iconId === 2"
              />
              <span
                class="ficon feather icon-shopping-bag"
                *ngIf="orderOnCategory.iconId === 3"
              ></span>
              <span
                class="ficon feather icon-gift"
                *ngIf="orderOnCategory.iconId === 4"
              ></span>
              <span
                class="ficon feather icon-heart"
                *ngIf="orderOnCategory.iconId === 5"
              ></span>
            </div>
            <div class="media-body" style="margin-left: 10px;">
              <div style="font-weight: 500;">
                <!--                We need to put the name of the category instead of id-->
                {{ orderOnCategory.categoryName }}
              </div>
              <div style="color: var(--main-color); font-weight: 600;">
                {{
                  orderOnCategory.count === 1
                    ? orderOnCategory.count +
                      ('DASHBOARD.ORDERS_CATEGORIES.BENEFIT' | translate)
                    : orderOnCategory.count +
                      ('DASHBOARD.ORDERS_CATEGORIES.BENEFITS' | translate)
                }}
              </div>
            </div>
            <div class="text-bold">
              {{ orderOnCategory.amount }} {{ 'DASHBOARD.UNIT' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
